import React, {createContext, useState, ReactElement, useEffect} from 'react';

export const NewProjectContext = createContext<$TSFixMe>({
  project: {},
  setProject: (project: any) => {},
  template: {},
  setTemplate: (template: any) => {},
  newProjectStep: 0,
  setNewProjectStep: (step: number) => {},
  questionIndex: 0,
  setQuestionIndex: (index: number) => {},
});

export const NewProjectProvider = ({children}: {children: ReactElement}) => {
  const [project, setProject] = useState({});
  const [template, setTemplate] = useState({});
  const [newProjectStep, setNewProjectStep] = useState<number>(0);
  const [questionIndex, setQuestionIndex] = useState<number>(0);

  const homeDepot = process.env.REACT_APP_HOME_DEPOT_MODE === '1';

  useEffect(() => {
    if (homeDepot && !newProjectStep) {
      setNewProjectStep(1);
      setTimeout(() => {
        const chatlio = document.getElementById('chatlio-custom-button');
        chatlio?.style.setProperty('display', 'none');
      }, 100);
    }
  }, [homeDepot, newProjectStep, setNewProjectStep]);

  const value = {
    project,
    setProject,
    template,
    setTemplate,
    newProjectStep,
    setNewProjectStep,
    questionIndex,
    setQuestionIndex,
    homeDepot,
  };

  return (
    <NewProjectContext.Provider value={value}>
      {children}
    </NewProjectContext.Provider>
  );
};
